import React, { Suspense } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";
import useIsMounted from "~/common/useIsMounted";
import PlusSubscriptionModal from "./PlusSubscriptionModal";
import { EnrollmentOption, PlusModalData, PlusPotentialSavingsInfo } from "../Models";
const LoginModalWrapper = React.lazy(() => import("~/common/LoginModal/LoginModalWrapper"));
interface PlusPageModalProps {
  user: User;
  plusModalData: PlusModalData;
  defaultShippingAddressId: number;
  enrollment: EnrollmentOption | undefined;
  addressPlusSignup: boolean;
  plusPotentialSavingsInfo: PlusPotentialSavingsInfo | undefined;
  isFreeview?: boolean;
  isOpenFromAd?: boolean;
}
const PlusPageModal = ({
  user,
  plusModalData,
  defaultShippingAddressId,
  enrollment,
  addressPlusSignup,
  plusPotentialSavingsInfo,
  isFreeview,
  isOpenFromAd = false
}: PlusPageModalProps) => {
  const mounted = useIsMounted();
  if (plusModalData && user.registered && (addressPlusSignup || !user.hasWebPlus || isFreeview)) {
    const modalProps = {
      userGuid: user.guid,
      shippingAddresses: plusModalData.validAddresses,
      defaultShippingAddressId,
      savedCardData: plusModalData.savedCardData,
      formattedPlusPrice: formatAsCurrency.formatIfUndefined(plusModalData.formattedPlusPrice).replace(".00", ""),
      enrollmentOptions: plusModalData.enrollmentOptions,
      enrollment,
      addressPlusSignup,
      plusPotentialSavingsInfo,
      isFreeview,
      subscriptionChargeDate: plusModalData.subscriptionChargeDate,
      isOpenFromAd
    };
    return <PlusSubscriptionModal {...modalProps} />;
  }
  if (!user.registered && mounted) {
    return <Suspense fallback={null}>
        <LoginModalWrapper />
      </Suspense>;
  }
  return null;
};
export default connectUserAndChat(PlusPageModal);